import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PopupForm from "../components/PopupForm";
import FloatingBar from "../components/FloatingBar";
import AreaCarousel from "../components/AreaCarousel";
import ContactCards from "../components/ContactCards";
import WhyChooseUs from "../components/WhyChooseUs";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Booking from "../components/Booking";
import Reviews from "../components/Reviews";

export default function Bokaro() {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const visited = localStorage.getItem("ro_first_visit");
        if (!visited) {
            setTimeout(() => setShowPopup(true), 3000);
            localStorage.setItem("ro_first_visit", "true");
        }
    }, []);

    return (
        <>
            <Helmet>
                <title> RO Service Bokaro @ 9031062015 | Water Purifier Repair & Services</title>
                <meta
                    name="description"
                    content="Same day RO water purifier repair, installation & AMC services in Bokaro. Call or WhatsApp now for fast service."
                />
                <meta name="keywords" content="ro service, water purifier service in Bokaro, ro repair, ro service near me, water purifier service near me, RO Service Bokaro, RO Service Bokaro near me, ro service centre, ro service centre in Bihar" />
                <meta name="keywords" content="ro service in Bokaro" />
                <meta name="keywords" content="Water purifier service in Bokaro" />
                <meta name="keywords" content="ro repair in Bokaro" />
                <meta name="author" content="Wappotix Pvt Ltd" />
                <meta name="description" content="RO Service Bokaro: We are India's leading RO water purifier repair and maintanance service provider of all brands like Kent, Pureit, Livpure, Aqua Guard, Aqua Fresh etc. RO repair service in Bokaro" ></meta>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "LocalBusiness",
                        name: "RO Service Center",
                        areaServed: Bokaro,
                        telephone: "9031062015",
                        serviceType: "RO Water Purifier Repair"
                    })}
                </script>
            </Helmet>

            <Hero title=" Bokaro" number="9031062015" />
            <Services />
            <Booking />
            <WhyChooseUs />
            <Reviews />
            <AreaCarousel />
            <ContactCards title=" Bokaro" number="9031062015" mapiframe="https://www.google.com/maps?q=Hazaribag,Jharkhand,India&output=embed" />
            <FloatingBar />
            <PopupForm show={showPopup} onClose={() => setShowPopup(false)} />
        </>
    );
}